module.exports = "/assets/1823299233a0ee571f857411f5466d74.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/UD.png
// module id = 3006
// module chunks = 0